//CRIANDO ACTION

import { createAction, props } from '@ngrx/store';

//padrão de nomenclatura tudo maiusculo
enum CustomBankActionType {
  //textos para acomparnharmos os estados de load customBank
  LOAD_CUSTOM_BANK = '[customBank] load customBank from api',
  LOAD_CUSTOM_BANK_SUCCESS = '[customBank] load customBank from api return success',
  LOAD_CUSTOM_BANK_ERROR = '[customBank] load customBank from api return error',
  SAVE_CUSTOM_BANK = '[customBank] save customBank from api',
  SAVE_CUSTOM_BANK_SUCCESS = '[customBank] edit customBank from api return success',
  EDIT_CUSTOM_BANK = '[customBank] edit customBank from api',
  EDIT_CUSTOM_BANK_SUCCESS = '[customBank] edit customBank from api return success',
  DELETE_CUSTOM_BANK = '[customBank] delete customBank from api',
}
export const loadCustomBank = createAction(
  CustomBankActionType.LOAD_CUSTOM_BANK
);
export const loadCustomBankSuccess = createAction(
  CustomBankActionType.LOAD_CUSTOM_BANK_SUCCESS,
  props<{ lista: any[] }>()
);
//vai para o effects
export const saveCustomBank = createAction(
  CustomBankActionType.SAVE_CUSTOM_BANK,
  props<{ customBank: any }>()
);
//vai para o reducer
export const saveCustomBankSuccess = createAction(
  CustomBankActionType.SAVE_CUSTOM_BANK_SUCCESS,
  props<{ customBank: any }>()
);
//vai para o effects
export const editCustomBank = createAction(
  CustomBankActionType.EDIT_CUSTOM_BANK,
  props<{ customBank: any; id: number }>()
);
//vai para o reducer
export const editCustomBankSuccess = createAction(
  CustomBankActionType.EDIT_CUSTOM_BANK_SUCCESS,
  props<{ customBank: any }>()
);

export const deleteCustomBank = createAction(
  CustomBankActionType.DELETE_CUSTOM_BANK,
  props<{ id: number }>()
);
